import { View } from './types';

export const teardownView = (view: View): void => {
  view.unmount();
};
